export default __webpack_public_path__ + "static/media/add.ec1d363f.jpg";